import qs from 'qs'
import { DateFactory } from 'rhg-vue-common'
import { getQueryParams } from '@/infrastructure/Utils'

// class to centralize existent data sources

export default class ExternalStorage {
  static cookies = {
    taxIncludedRegion: () => {
      try {
        const countryList = global.ConfigDynamic.valueOf(global.configDynamicKey.DEFAULT_TAXES_INCLUDED_COUNTRY_CODES).split(',')
        const countryCookie = global.Cookie.read(global.cookieDictionary.akamai) && qs.parse(global.Cookie.read(global.cookieDictionary.akamai)).country
        return countryList.some(country => country === countryCookie)
      } catch (e) {
        return false
      }
    },
    taxExcludedRegion: () => {
      try {
        const countryList = global.ConfigDynamic.valueOf(global.configDynamicKey.DEFAULT_TAXES_EXCLUDED_COUNTRY_CODES).split(',')
        const countryCookie = global.Cookie.read(global.cookieDictionary.akamai) && qs.parse(global.Cookie.read(global.cookieDictionary.akamai)).country
        return countryList.some(country => country === countryCookie)
      } catch (e) {
        return false
      }
    },
    isUk: () => global.Cookie.read(global.cookieDictionary.akamai) && qs.parse(global.Cookie.read(global.cookieDictionary.akamai)).country === 'GB',
    isIndia: () => global.Cookie.read(global.cookieDictionary.akamai) && qs.parse(global.Cookie.read(global.cookieDictionary.akamai)).country === 'IN',
    siteId: () => global.Cookie.read(global.cookieDictionary.siteId),
    facilitatorId: () => global.Cookie.read(global.cookieDictionary.altFacilitatorId) || global.Cookie.read(global.cookieDictionary.facilitatorId),
    preferredCurrency: () => global.Cookie.read('preferredCurrency'),
    savePreferredCurrency: (currency) => {
      return global.Cookie.create('preferredCurrency', currency.code, { expires: DateFactory.addDays(DateFactory.today(), 30) })
    },
    acceptLoyaltyConsent: () => global.Cookie.set(global.cookieDictionary.loyaltyConsentRates, true)
  }

  static global = {
    device: () => global.device,
    sourceOfBusiness: () => global.device.desktop() ? 'desktop' : 'mobile',
    isWebView: () => !!global.UtilsUrl && global.UtilsUrl.getURLParameter('app') === 'true'
  }

  static session = {
    transactionId: () => sessionStorage.getItem('transactionId'), // EMMA
    travelAgencyCustomerId: () => sessionStorage.getItem('travelAgencyCustomerId'), // parameter from rates to preBooking
    promotionalCodeGroupId: () => sessionStorage.getItem('promotionalCodeGroupId'), // parameter from rates to preBooking
    saveTravelAgencyCustomerId: (travelAgencyCustomerId) => travelAgencyCustomerId ? sessionStorage.setItem('travelAgencyCustomerId', travelAgencyCustomerId) : sessionStorage.removeItem('travelAgencyCustomerId'),
    savePromotionalCodeGroupId: (promotionalCodeGroupId) => promotionalCodeGroupId ? sessionStorage.setItem('promotionalCodeGroupId', promotionalCodeGroupId) : sessionStorage.removeItem('promotionalCodeGroupId'),
    brandPreference: () => global.SessionStorage.get(global.sessionStorageDictionary.externalBrandPreference) || global.SessionStorage.get(global.sessionStorageDictionary.brandPreference) || 'rhg',
    brand: () => global.SessionStorage.get(global.sessionStorageDictionary.brandPreference) || global.SessionStorage.get(global.sessionStorageDictionary.externalBrandPreference),
    brandOptIn: () => global.SessionStorage.get(global.sessionStorageDictionary.brandPreference) || global.SessionStorage.get(global.sessionStorageDictionary.externalBrandPreference) || 'rhg'
  }

  static local = {
    saver: (localStorage.getItem('saver') || 'true') === 'true',
    hotelInformation: (hotel) => {
      const hotelInfo = {
        hotelName: hotel.name,
        hotelImage: hotel.defaultImage,
        hotelAddress: hotel.address
      }
      localStorage.setItem('hotelInformation', JSON.stringify(hotelInfo))
    }
  }

  static appGlobalProps = {
    isRezidorHotel: global.appGlobalProps && global.appGlobalProps.isRezidorHotel === 'Yes'
  }

  static url = {
    params: getQueryParams(window.location._search || window.location.search),
    setParams: (param, value) => {
      const currentUrl = new URL(window.location.href)
      currentUrl.searchParams.set(param, value)
      window.history.replaceState({}, document.title, currentUrl.href)
    }
  }
}
